import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Navbar from '../Components/Navbar';
import Main from './Main';
import About from './About';
import Projects from './Projects';
import Blog from './Blog';
import Contact from './Contact';
import Login from './Login';
import RezepeBlog from './BlogPosts/RezepeBlog';
import LibraryBlog from './BlogPosts/LibraryBlog';
import AICloneBlog from './BlogPosts/AICloneBlog';
import HomeNASBlog from './BlogPosts/HomeNASBlog';
import UbuntuLabBlog from './BlogPosts/UbuntuLabBlog';
import CapyJumpBlog from './BlogPosts/CapyJumpBlog';
import PortfolioBlog from './BlogPosts/PortfolioBlog';
import BlogPost from './BlogPost';
import '../CSS/App.css';

const ScrollToTop = () => {
    const { pathname } = useLocation();
    useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
    return null;
};

const App = () => {
    return (
        <Router>
            <ScrollToTop />
            <Navbar />
            <Routes>
                <Route path="/" element={<Main />} />
                <Route path="/about" element={<About />} />
                <Route path="/projects" element={<Projects />} />
                <Route path="/blog" element={<Blog />} />
                <Route path="/blog/rezepe" element={<RezepeBlog />} />
                <Route path="/blog/library" element={<LibraryBlog />} />
                <Route path="/blog/ai-clone" element={<AICloneBlog />} />
                <Route path="/blog/home-nas" element={<HomeNASBlog />} />
                <Route path="/blog/ubuntu-lab" element={<UbuntuLabBlog />} />
                <Route path="/blog/capy-jump" element={<CapyJumpBlog />} />
                <Route path="/blog/portfolio" element={<PortfolioBlog />} />
                <Route path="/blog/:slug" element={<BlogPost />} />
                <Route path="/Contact" element={<Contact />} />
                <Route path="/login" element={<Login />} />
            </Routes>
        </Router>
    );
};

export default App;
